import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TCreateMerchantReqData,
  TCreateMerchantResData,
  TDeleteMerchantResData,
  TGetMerchantInfoResData,
  TGetMerchantsListParams,
  TGetMerchantsListResData,
  TUpdateMerchantReqData,
  TUpdateMerchantResData,
} from '../types/merchant.types';

export const getMerchantsListService = async (
  counterpartyGUID: string,
  params: TGetMerchantsListParams
): Promise<TGetMerchantsListResData> => {
  const config = { params };
  const url = API_ENDPOINTS.MERCHANT.MERCHANTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.get<TGetMerchantsListResData>(url, config);

  return res.data;
};

export const createMerchantService = async (
  counterpartyGUID: string,
  reqData: TCreateMerchantReqData
): Promise<TCreateMerchantResData> => {
  const url = API_ENDPOINTS.MERCHANT.MERCHANTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TCreateMerchantResData>(url, reqData);

  return res.data;
};

export const getMerchantInfoService = async (merchantGUID: string): Promise<TGetMerchantInfoResData> => {
  const url = API_ENDPOINTS.MERCHANT.MERCHANT.replace(EApiPathParams.MerchantGuid, merchantGUID);
  const res = await apiClient.get<TGetMerchantInfoResData>(url);

  return res.data;
};

export const updateMerchantService = async (
  merchantGUID: string,
  reqData: TUpdateMerchantReqData
): Promise<TUpdateMerchantResData> => {
  const url = API_ENDPOINTS.MERCHANT.MERCHANT.replace(EApiPathParams.MerchantGuid, merchantGUID);
  const res = await apiClient.put<TUpdateMerchantResData>(url, reqData);

  return res.data;
};

export const deleteMerchantService = async (merchantGUID: string): Promise<TDeleteMerchantResData> => {
  const url = API_ENDPOINTS.MERCHANT.MERCHANT.replace(EApiPathParams.MerchantGuid, merchantGUID);
  const res = await apiClient.delete<TDeleteMerchantResData>(url);

  return res.data;
};
